(function (app, ng) {
    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Tools.MarketPlace.ElevateLifeAssets",
            {
                url: "/ElevateLifeAssets",
                component: "elevatelifeassets",
                PageTitle: "Elevate for Life Assets",
                resolve: {
                    states: ["states", function (states) {
                        return states;
                    }]
                }
            });
        }
    ]);

    app.component("elevatelifeassets",
    {
        templateUrl: "App/Tools/MarketPlace/ElevateLifeAssets/ElevateLifeAssets.html",
        controller: elevateLifeAssetsCtrl,
        bindings: {
            states: "<"
        }
    });

    elevateLifeAssetsCtrl.$inject = ["externalLoading"];
    function elevateLifeAssetsCtrl(externalLoading) {
        var $ctrl = this;
    
        //this.ActivateTaylorMethodSso = function () {
        //    var w = window.open();
        //    w.document.write(externalLoading.html);
        //    elevateLifeApi.initiateTaylorMethodSso().then(function (data) {
        //        //console.log(data);          
        //        w.document.write(data);
        //        w.document.forms.samlform.submit();
        //    }, function () {
        //        w.document.write(" Failed.  There was an error accessing this resource.");
        //    });
        //}

        //this.ActivatePowerOfZeroSso = function () {
        //    var w = window.open();
        //    w.document.write(externalLoading.html);
        //    elevateLifeApi.initiatePowerOfZeroSso().then(function (data) {
        //        //console.log(data);
        //        w.document.write(data);
        //        w.document.forms.powerofzero.submit();
        //    }, function () {
        //        w.document.write(" Failed.  There was an error accessing this resource.");
        //    });
        //}

        //this.ActivateElevate4LifeSso = function () {
        //    var w = window.open();
        //    w.document.write(externalLoading.html);
        //    elevateLifeApi.initiateElevate4LifeSso().then(function (data) {
        //        //console.log(data);
        //        w.document.write(data);
        //        w.document.forms.platinum.submit();
        //    }, function () {
        //        w.document.write(" Failed.  There was an error accessing this resource.");
        //    });
        //};      
    }

    app.config(["$urlRouterProvider", function ($urlRouterProvider) {
        $urlRouterProvider.when("/Tools/MarketPlace/ElevateLifeAssets", "/Tools/MarketPlace/ElevateLifeAssets/Default");
    }]);
})(window.app, window.angular); // jshint ignore:line